import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgHeadphone(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2c5.523 0 10 4.477 10 10v7a3 3 0 0 1-3 3h-4V11h4c.334 0 .655.056.955.157a8 8 0 0 0-15.911 0c.3-.1.622-.157.956-.157h4v11H5a3 3 0 0 1-3-3v-7C2 6.477 6.477 2 12 2ZM5 13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h2v-7H5Zm12 7h2a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2v7Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgHeadphone)
